<template>
  <div class="container-box">
    <div id="geoContainer" :style="{'height':'100vh','width':'100%'}"></div>
    <!-- <router-link to='/businessm/creategoods'> -->
    <el-button type="primary" class="main-cancel" @click="reportGO()" ref="backgo">返回</el-button>
    <!-- </router-link> -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import { post, get } from "../../api/ajax";
export default {
  name: "electricMap",
  data() {
    return {
      mapCtx: "",
      district: "",
      disProvince: "",
      colors: {},
      lng: "", //经纬度
      lat: "",
      startLoc: "", //起运点
      endLoc: "" //卸货点
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.startLoc = this.$route.query.startLoc;
      this.endLoc = this.$route.query.endLoc;
      console.log(this.startLoc, this.endLoc);
      //地图加载
      // 定位大致范围
      this.showMapForLoc(this.startLoc);
      //绘制围栏
      this.showMapForDis(this.startLoc);
      this.showMapForDis(this.endLoc);
    });
  },
  watch: {
    $route(to, from) {
      this.startLoc = this.$route.query.startLoc;
      this.endLoc = this.$route.query.endLoc;
      // 定位大致范围
      this.showMapForLoc(this.startLoc);
      //绘制围栏
      this.showMapForDis(this.startLoc);
      this.showMapForDis(this.endLoc);
    }
  },
  methods: {
    showMapForDis(addrrss) {
      let that = this;
      new AMap.DistrictSearch({
        extensions: "all",
        subdistrict: 0
      }).search(addrrss, function(status, result) {
        // 外多边形坐标数组和内多边形坐标数组
        var outer = [
          new AMap.LngLat(360, 90, true),
          new AMap.LngLat(360, 90, true),
          new AMap.LngLat(360, 90, true),
          new AMap.LngLat(360, 90, true)
        ];
        var holes = result.districtList[0].boundaries;

        var pathArray = [outer];
        pathArray.push.apply(pathArray, holes);
        var polygon = new AMap.Polygon({
          pathL: pathArray,
          //线条颜色，使用16进制颜色代码赋值。默认值为#006600
          strokeColor: "#F00",
          strokeWeight: 2,
          //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
          strokeOpacity: 1,
          //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
          fillColor: "#007fcc",
          //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
          fillOpacity: 0.5,
          //轮廓线样式，实线:solid，虚线:dashed
          strokeStyle: "solid",

          strokeDasharray: [10, 2, 10]
        });
        polygon.setPath(pathArray);
        if (that.mapCtx) {
          that.mapCtx.add(polygon);
        }
      });
    },
    reportGO() {
      // this.$forceUpdate();
      this.$router.go(-1);
      // this.$router.push("/businessm/creategoods");
    },
    showMapForLoc(address) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function() {
        let geocoder = new AMap.Geocoder();
        geocoder.getLocation(address, function(status, result) {
          if (status === "complete" && result.info === "OK") {
            // 经纬度
            that.lng = result.geocodes[0].location.lng;
            that.lat = result.geocodes[0].location.lat;
            // // 地图实例
            let map = new AMap.Map("geoContainer", {
              resizeEnable: true, // 允许缩放
              center: [that.lng, that.lat], // 设置地图的中心点
              zoom: 10 // 设置地图的缩放级别，0 - 20
            });
            that.mapCtx = map;

            // // 添加标记
            var marker = new AMap.Marker({
              map: map,
              position: new AMap.LngLat(that.lng, that.lat) // 经纬度
            });
          } else {
            console.log("定位失败！");
          }
        });
      });
    }
  }
};
</script>
<style scoped>
.main-cancel {
  position: fixed;
  bottom: 30px;
  z-index: 999;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/page/businessm/geoGraphic.vue